const TREATMENTS = [
    'gift-card-ui',
    'show-breakfast-banner'
];

export default TREATMENTS;
